module.exports = __webpack_public_path__ + "img/img14.48a248cb.jpg";